import Avatar from '@atlaskit/avatar';
import { Box, Inline, Stack } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { ExternalLink, H1, H2 } from '@atlassian/mpac-primitives';

import { InnerContainer, OuterContainer } from './ArchivedVendorsPage.styles';

const ArchivedVendorsPage = () => {
  const partnerName = 'robert plant';
  const partnerEmail = 'rkashyap@atlassian.com';
  const archivedApps = []; // empty to show "0 Apps"

  return (
    <OuterContainer>
      <InnerContainer>
        <Stack space="space.600">
          <Box testId="archived-vendor-banner" style={{ width: '100%' }}>
            <SectionMessage appearance="warning">
              <p>
                This vendor has been archived. You may still get support information and download
                previous versions of this app.{' '}
                <ExternalLink
                  href="https://www.atlassian.com/licensing/marketplace#general-faqs"
                  size="small"
                >
                  Learn more
                </ExternalLink>{' '}
                .
              </p>
            </SectionMessage>
          </Box>

          <Stack space="space.200">
            <Inline space="space.300" alignBlock="center">
              <Avatar size="large" appearance="circle" name={partnerName} />
              <H1 style={{ textTransform: 'capitalize', margin: 0, lineHeight: 1 }}>
                {partnerName}
              </H1>
            </Inline>
            <p>Email ID: {partnerEmail}</p>
          </Stack>

          <Stack space="space.200">
            <H2>0 Apps</H2>
            <Box padding="space.400" backgroundColor="color.background.neutral.subtle">
              {archivedApps.length ? (
                <p>Todo Apps information</p>
              ) : (
                <p>No archived apps found for this vendor.</p>
              )}
            </Box>
          </Stack>
        </Stack>
      </InnerContainer>
    </OuterContainer>
  );
};

export default ArchivedVendorsPage;
